/**
 * Setup the environment for photo mount items
 */
import { Logger } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Setup the environment for photo mount items
 */
export default class PhotoMountItemEnvironment {
    /**
     * @param {AbstractItem} item
     * @param {Pimple} container
     */
    constructor(item, container) {
        this.item = item;

        this.container = container;
        this.layerManager = container.get('canvas.svg.layerManager');
        this.contextManager = container.get('canvas.contextManager');
        this.pathFactory = container.get('canvas.svg.pathFactory');
    }

    init() {
        Logger.debug('PhotoMountItemEnvironment.init():', this.item);

        this.context = new Ofcs.Editor.Context.Context(this.item, 'photoMount');

        this.itemLayer = this.layerManager.createItemLayer(this.item, {
            transform: this.pathFactory.getAbsoluteTransformString(this.item),
        });

        // Move item layer when the foam item is moved inside a box
        this.item.on('change', (photoMount) => {
            if (photoMount.hasChangedProperty('position')) {
                this.itemLayer.getElement().attr(
                    'transform',
                    this.pathFactory.getAbsoluteTransformString(photoMount, true),
                );
            }
        });

        // photo mount layer
        this.layerManager.createLayer('photo-mount', null, false, this.itemLayer);

        // bags layer
        this.layerManager.createLayer('bags', null, false, this.itemLayer);

        // images layer
        this.layerManager.createLayer('images', null, false, this.itemLayer);
    }

    activate() {
        Logger.debug('PhotoMountItemEnvironment.activate():', this.item);

        this.itemLayer.show();
        this.contextManager.addContext(this.context);
    }

    deactivate() {
        Logger.debug('PhotoMountItemEnvironment.deactivate():', this.item);

        this.itemLayer.hide();
        this.contextManager.removeContext(this.context);
    }
}
